import * as React from 'react';

import Notifications32 from './Notifications32';

export const notifications32 = () => <Notifications32 />;

export default {
    title: 'Icon/Logo/Notifications32',
    component: Notifications32,
    parameters: {
        notes: "`import Notifications32 from 'box-ui-elements/es/icon/logo/Notifications32';`",
    },
};
